import { FC, useState, MutableRefObject } from 'react';
// 组件
import { ProModal, ProCheckbox, ProRow, ProCol } from '../../antd';
// 常量
import { ModalTableActionType } from '../../constants/interface';
import { columnsProps } from '../interface';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

interface CopyColumnsModalProps {
  isFba?: boolean;
  defaultUnrepeated?: boolean;
  copyColumns?: columnsProps[];
  copyColumnsModalRef: MutableRefObject<ModalTableActionType>;
  /** 是否为主子表 */
  isMainSubTable?: boolean;
  onOk: (
    values: any[],
    isUnrepeated: boolean,
    isCopyTitle: boolean,
    isMainData?: boolean,
    isSubData?: boolean,
  ) => void;
}
/** 复制列选择 */
const CopyColumnsModal: FC<CopyColumnsModalProps> = props => {
  const {
    copyColumns,
    copyColumnsModalRef,
    defaultUnrepeated,
    isMainSubTable,
    isFba,
    onOk,
  } = props;
  const [visible, setVisible] = useState<boolean>(false);
  /** TODO 特殊代码 */
  const [checkAll, setCheckAll] = useState<boolean>(true);
  const [isMainData, setIsMainData] = useState<boolean>(false);
  const [isSubData, setIsSubData] = useState<boolean>(true);
  const [isUnrepeated, setIsUnrepeated] = useState<boolean>(!isMainSubTable);
  const [copyTitle, setCopyTitle] = useState<boolean>(false);
  const [groupValue, setGroupValue] = useState<any[]>([]);
  // 取消
  const handleCancel = () => {
    setVisible(false);
  };
  // 确定
  const handleOk = () => {
    isMainSubTable
      ? onOk(groupValue, isUnrepeated, copyTitle, isMainData, isSubData)
      : onOk(groupValue, isUnrepeated, copyTitle);
    setVisible(false);
  };
  // 选项改变
  const handleChange = (checkedValue: any[]) => {
    setGroupValue(checkedValue);
  };
  // 是否去重
  const handleChangeUnrepeated = (e: CheckboxChangeEvent) => {
    const checked: boolean = e.target.checked;
    setIsUnrepeated(checked);
  };
  /** TODO 特殊代码 */
  const handleCheckAllChange = (e: any) => {
    const checked = e.target.checked;
    setCheckAll(checked);
    if (copyColumns) {
      setGroupValue(
        checked
          ? copyColumns?.map(item => {
              const { dataIndex } = item;
              return dataIndex as string;
            })
          : [],
      );
    }
  };
  /** 是否复制标题 */
  const handleChangeCopyTitle = (e: CheckboxChangeEvent) => {
    const checked: boolean = e.target.checked;
    setCopyTitle(checked);
  };
  /** 是否复制主表数据 */
  const handleChangeMainData = (e: CheckboxChangeEvent) => {
    const checked: boolean = e.target.checked;
    setIsMainData(checked);
  };
  /** 是否复制子表 */
  const handleChangeSubData = (e: CheckboxChangeEvent) => {
    const checked: boolean = e.target.checked;
    setIsSubData(checked);
  };
  const handleShow = () => {
    setVisible(true);
    setGroupValue(
      isFba && copyColumns ? copyColumns.map(v => v.dataIndex as string) : [],
    );
    setIsUnrepeated(!!defaultUnrepeated);
  };
  copyColumnsModalRef.current = {
    show: handleShow,
    hide: handleCancel,
  };
  return (
    <ProModal
      open={visible}
      width={isFba ? 650 : 520}
      title="请选择需要复制的列"
      destroyOnClose
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleOk}
      okButtonProps={{
        disabled: !groupValue?.length,
      }}
    >
      <ProRow
        gutter={24}
        style={{
          marginBottom: 24,
          paddingBottom: 24,
          borderBottom: 'solid 1px #f0f0f0',
        }}
      >
        {isFba && (
          <>
            <ProCol>
              <ProCheckbox onChange={handleCheckAllChange} checked={checkAll}>
                全选
              </ProCheckbox>
            </ProCol>
            <ProCol>
              <ProCheckbox checked={copyTitle} onChange={handleChangeCopyTitle}>
                是否需要复制标题
              </ProCheckbox>
            </ProCol>
          </>
        )}
        <ProCol>
          <ProCheckbox checked={isUnrepeated} onChange={handleChangeUnrepeated}>
            是否需要去除重复数据
          </ProCheckbox>
        </ProCol>
        {isMainSubTable && (
          <>
            <ProCol>
              <ProCheckbox checked={isMainData} onChange={handleChangeMainData}>
                主表数据
              </ProCheckbox>
            </ProCol>
            <ProCol>
              <ProCheckbox checked={isSubData} onChange={handleChangeSubData}>
                子表数据
              </ProCheckbox>
            </ProCol>
          </>
        )}
      </ProRow>
      <ProCheckbox.Group
        style={{ width: '100%' }}
        value={groupValue}
        onChange={handleChange}
      >
        <ProRow gutter={24}>
          {copyColumns?.map(column => {
            const { dataIndex, title, } = column;
            return (
              <ProCol span={8} key={dataIndex as string}>
                <ProCheckbox value={dataIndex}>{title}</ProCheckbox>
              </ProCol>
            );
          })}
        </ProRow>
      </ProCheckbox.Group>
    </ProModal>
  );
};

CopyColumnsModal.defaultProps = {
  defaultUnrepeated: true,
};

export default CopyColumnsModal;
